import React from 'react';

import './updatePaymentStyle.scss';

const BasicText = (props) => {
  return (
    <>
      {props.text.split('\n').map((str, i) => (
        <div
          key={i}
          className={
            'paymentupdate-basictext' +
            (props.bold ? '-bold ' : ' ') +
            (props.classname ? props.classname : ' ') +
            (props.color ? props.color : '')
          }>
          {str}
        </div>
      ))}
    </>
  );
};

export default BasicText;
